import { Title, Text, Group, Box, ActionIcon, Stack } from '@mantine/core';
import { X } from 'react-feather';
import { CircleBackButton } from '../../../components/common/CircleBackButton';

export interface PageHeaderProps {
  cohortName: string;
  onBack: () => void;
  onClose: () => void;
}

export function PageHeader({ cohortName, onBack, onClose }: PageHeaderProps) {
  return (
    <Box
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'white',
        borderBottom: '1px solid var(--mantine-color-gray-2)',
      }}
      py="md"
      px="lg"
    >
      <Group justify="space-between" align="flex-start">
        <Group gap="md" align="flex-start" wrap="nowrap">
          <CircleBackButton onClick={onBack} aria-label="Back to Dashboard" />
          <Stack gap={2}>
            <Title order={3}>Cohort Availability</Title>
            <Text c="dimmed" size="sm">
              {cohortName}
            </Text>
          </Stack>
        </Group>
        <ActionIcon variant="subtle" onClick={onClose} size="lg">
          <X size={20} />
        </ActionIcon>
      </Group>
    </Box>
  );
}
